import { render, staticRenderFns } from "./realTimeData.vue?vue&type=template&id=7bd34dbc&scoped=true&"
import script from "./realTimeData.vue?vue&type=script&lang=js&"
export * from "./realTimeData.vue?vue&type=script&lang=js&"
import style0 from "./realTimeData.vue?vue&type=style&index=0&id=7bd34dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd34dbc",
  null
  
)

export default component.exports